/* JO MATTER global script: cart drawer, wishlist, quick view, toasts. Loaded on every page. */
(function () {
  if (window.JM) return;
  var JM = window.JM = {};
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var MP_PIN = /^4[5-8]\d{4}$/;

  function money(c) { return 'Rs. ' + (Number(c) / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function img(url, w) { if (!url) return ''; url = String(url); return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function cssColor(n) { return String(n || '').toLowerCase().replace(/\s+/g, ''); }
  function req(url, body) {
    var o = body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } };
    return fetch(url, o).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (d) {
        if (!r.ok || d.status) throw new Error(d.description || d.message || 'Something went wrong. Please try again.');
        return d;
      });
    });
  }
  JM.money = money; JM.esc = esc; JM.img = img; JM.cssColor = cssColor; JM.root = ROOT;

  var I = {
    heart: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20s-7-4.5-9-9a5 5 0 019-3 5 5 0 019 3c-2 4.5-9 9-9 9z"/></svg>',
    eye: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/></svg>',
    trash: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13M10 11v6M14 11v6"/></svg>',
    truck: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h11v10H3zM14 9h4l3 3v4h-7z"/><circle cx="7" cy="18" r="2"/><circle cx="17" cy="18" r="2"/></svg>',
    close: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>'
  };
  JM.icons = I;

  /* ---------- toast ---------- */
  JM.toast = function (msg, link, linkText) {
    var old = document.querySelector('.jm-toast'); if (old) old.remove();
    var t = document.createElement('div'); t.className = 'jm-toast'; t.setAttribute('role', 'status');
    var s = document.createElement('span'); s.textContent = msg; t.appendChild(s);
    if (link) { var a = document.createElement('a'); a.href = link; a.textContent = linkText || 'View'; t.appendChild(a); }
    document.body.appendChild(t);
    setTimeout(function () { t.remove(); }, 3500);
  };

  /* ---------- theme events (keeps the header cart count in sync) ---------- */
  var ev = null, selfEvent = false;
  var evReady = import('@shopify/events').then(function (m) { ev = m; }).catch(function () {});
  JM.notify = function (cart, action) {
    document.dispatchEvent(new CustomEvent('jm:cart', { detail: { count: cart.item_count, cart: cart } }));
    return evReady.then(function () {
      if (!ev || !ev.CartLinesUpdateEvent) return;
      try {
        var d = ev.CartLinesUpdateEvent.createPromise();
        selfEvent = true;
        document.dispatchEvent(new ev.CartLinesUpdateEvent({ action: action || 'update', context: 'jm', lines: [], promise: d.promise }));
        selfEvent = false;
        d.resolve({ cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { source: 'jm', items: cart.items, itemCount: cart.item_count } });
      } catch (e) { selfEvent = false; }
    });
  };

  /* ---------- cart API ---------- */
  var pcache = {};
  JM.product = function (handle) {
    if (!pcache[handle]) pcache[handle] = fetch(ROOT + 'products/' + handle + '.js').then(function (r) { if (!r.ok) throw new Error('Not found'); return r.json(); });
    return pcache[handle];
  };
  JM.getCart = function () { return req(ROOT + 'cart.js'); };
  JM.add = function (items, opts) {
    opts = opts || {};
    return req(ROOT + 'cart/add.js', { items: items }).then(function () { return JM.getCart(); }).then(function (cart) {
      JM.notify(cart, 'add');
      if (JM.drawer) { JM.drawer.render(cart); if (opts.open !== false) JM.drawer.open(); }
      else if (opts.open !== false) JM.toast('Added to cart', ROOT + 'cart', 'View cart');
      return cart;
    });
  };
  JM.change = function (key, qty) {
    return req(ROOT + 'cart/change.js', { id: key, quantity: qty }).then(function (cart) {
      JM.notify(cart, qty === 0 ? 'remove' : 'update');
      if (JM.drawer) JM.drawer.render(cart);
      return cart;
    });
  };

  /* ---------- wishlist (saved in this browser) ---------- */
  var WK = 'jm_wish';
  function wl() { try { var a = JSON.parse(localStorage.getItem(WK) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function wsave(a) { try { localStorage.setItem(WK, JSON.stringify(a)); } catch (e) {} JM.paint(); document.dispatchEvent(new CustomEvent('jm:wish', { detail: { list: a } })); }
  JM.wish = {
    list: wl,
    has: function (h) { return wl().indexOf(h) > -1; },
    toggle: function (h) { var a = wl(), i = a.indexOf(h); if (i > -1) a.splice(i, 1); else a.unshift(h); wsave(a); return i === -1; }
  };
  JM.paint = function () {
    var a = wl();
    document.querySelectorAll('[data-jm-wish]').forEach(function (b) {
      var on = a.indexOf(b.getAttribute('data-jm-wish')) > -1;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
      var t = b.querySelector('.jm-tip'); if (t) t.textContent = on ? 'Remove from wishlist' : 'Add to wishlist';
    });
    document.querySelectorAll('[data-jm-wish-count]').forEach(function (e) { e.textContent = a.length; });
  };
  window.addEventListener('storage', function (e) { if (e.key === WK) JM.paint(); });

  /* ---------- card markup used by JS-built grids ---------- */
  JM.actionsHTML = function (h) {
    return '<div class="jm-card__actions"><button type="button" class="jm-icon-btn jm-act" data-jm-wish="' + esc(h) + '" aria-label="Add to wishlist">' + I.heart + '<span class="jm-tip">Add to wishlist</span></button><button type="button" class="jm-icon-btn jm-act" data-jm-qv="' + esc(h) + '" aria-label="Quick view">' + I.eye + '<span class="jm-tip">Quick view</span></button></div>';
  };
  JM.cardHTML = function (p) {
    var pct = p.compare_at_price > p.price ? Math.round((p.compare_at_price - p.price) * 100 / p.compare_at_price) : 0;
    var im = p.featured_image ? '<img src="' + img(p.featured_image, 600) + '" alt="' + esc(p.title) + '" loading="lazy">' : '';
    return '<article class="jm-card jm-card--box">' + (pct ? '<span class="jm-badge">-' + pct + '%</span>' : (p.available ? '' : '<span class="jm-badge jm-badge--out">Sold out</span>')) +
      JM.actionsHTML(p.handle) +
      '<a class="jm-card__media" href="' + p.url + '">' + im + '</a><a class="jm-card__title" href="' + p.url + '">' + esc(p.title) + '</a><span class="jm-price">' + money(p.price) + (pct ? '<s>' + money(p.compare_at_price) + '</s>' : '') + '</span></article>';
  };

  /* ---------- cart drawer ---------- */
  class JMDrawer extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      JM.drawer = this;
      this.th = parseInt(this.dataset.threshold, 10) || 79800;
      var self = this;
      this.addEventListener('click', function (e) {
        if (e.target.closest('[data-close]')) { e.preventDefault(); self.close(); return; }
        var tool = e.target.closest('[data-tool]');
        if (tool) {
          var p = self.querySelector('[data-panel="' + tool.dataset.tool + '"]');
          var wasOpen = p && !p.hidden;
          self.querySelectorAll('[data-panel]').forEach(function (x) { x.hidden = true; });
          self.querySelectorAll('[data-tool]').forEach(function (x) { x.classList.remove('is-on'); x.setAttribute('aria-expanded', 'false'); });
          if (p && !wasOpen) { p.hidden = false; tool.classList.add('is-on'); tool.setAttribute('aria-expanded', 'true'); var f = p.querySelector('textarea, input'); if (f) f.focus(); }
          return;
        }
        var btn = e.target.closest('[data-act]');
        if (btn) self.act(btn);
      });
      this.addEventListener('change', function (e) { var s = e.target.closest('[data-swap]'); if (s) self.swap(s); });
      this.addEventListener('keydown', function (e) { if (e.key === 'Enter' && e.target.matches('[data-pin]')) { e.preventDefault(); self.checkShip(); } });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && self.isOpen) self.close(); });
      evReady.then(function () {
        if (ev && ev.StandardEvents) document.addEventListener(ev.StandardEvents.cartLinesUpdate, function (e) {
          if (selfEvent) return;
          (e.promise || Promise.resolve()).then(function () { self.refresh(); }).catch(function () {});
        });
      });
      window.addEventListener('pageshow', function (e) { if (e.persisted) self.refresh(); });
      this.refresh();
    }
    get isOpen() { return this.classList.contains('is-open'); }
    open() {
      this._last = document.activeElement;
      this.classList.add('is-open');
      this.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('jm-lock');
      var x = this.querySelector('.jm-cd__x'); if (x) setTimeout(function () { x.focus(); }, 60);
    }
    close() {
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');
      if (!document.querySelector('.jm-qv.is-open')) document.documentElement.classList.remove('jm-lock');
      if (this._last && this._last.focus) this._last.focus();
    }
    toggle() { if (this.isOpen) this.close(); else this.open(); }
    refresh() { var self = this; return JM.getCart().then(function (c) { self.render(c); }).catch(function () {}); }
    act(btn) {
      var a = btn.dataset.act, self = this, line = btn.closest('[data-key]');
      if (a === 'inc' || a === 'dec' || a === 'del') {
        var q = parseInt(line.dataset.qty, 10) || 0;
        var nq = a === 'inc' ? q + 1 : a === 'dec' ? q - 1 : 0;
        line.classList.add('is-busy');
        JM.change(line.dataset.key, Math.max(0, nq)).catch(function (err) { line.classList.remove('is-busy'); JM.toast(err.message); });
      } else if (a === 'add-rec') {
        btn.disabled = true; btn.textContent = 'Adding...';
        JM.add([{ id: +btn.dataset.id, quantity: 1 }]).catch(function (err) { btn.disabled = false; btn.textContent = 'Add'; JM.toast(err.message); });
      } else if (a === 'note-save') {
        var v = this.querySelector('[data-note]').value;
        btn.textContent = 'Saving...';
        req(ROOT + 'cart/update.js', { note: v }).then(function () { btn.textContent = 'Saved'; setTimeout(function () { btn.textContent = 'Save note'; }, 1500); }).catch(function () { btn.textContent = 'Save note'; JM.toast('Could not save the note.'); });
      } else if (a === 'ship-check') { this.checkShip(); }
    }
    swap(sel) {
      var line = sel.closest('[data-key]'), self = this;
      var key = line.dataset.key, q = parseInt(line.dataset.qty, 10) || 1, vid = +sel.value;
      line.classList.add('is-busy');
      req(ROOT + 'cart/add.js', { items: [{ id: vid, quantity: q }] })
        .then(function () { return JM.change(key, 0); })
        .catch(function (err) { JM.toast(err.message); self.refresh(); });
    }
    checkShip() {
      var inp = this.querySelector('[data-pin]'), out = this.querySelector('[data-ship-out]');
      var pin = String(inp.value || '').replace(/\D/g, '');
      if (pin.length !== 6) { out.innerHTML = '<p class="jm-cd__err">Please enter a valid 6-digit pincode.</p>'; return; }
      if (!MP_PIN.test(pin)) { out.innerHTML = '<p class="jm-cd__err">Sorry, right now we deliver only within Madhya Pradesh.</p>'; return; }
      out.innerHTML = '<p class="jm-cd__rate">Checking...</p>';
      var q = 'shipping_address%5Bzip%5D=' + pin + '&shipping_address%5Bcountry%5D=India&shipping_address%5Bprovince%5D=Madhya%20Pradesh';
      fetch(ROOT + 'cart/shipping_rates.json?' + q, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var rates = (d && d.shipping_rates) || [];
          if (!rates.length) { out.innerHTML = '<p class="jm-cd__err">No delivery option found for this pincode.</p>'; return; }
          out.innerHTML = rates.map(function (r) {
            var p = parseFloat(r.price) || 0;
            var days = r.delivery_days && r.delivery_days.length ? ' &middot; ' + r.delivery_days.join('&ndash;') + ' business days' : '';
            return '<p class="jm-cd__rate"><b>' + esc(r.name) + '</b><span>' + (p > 0 ? money(Math.round(p * 100)) : 'FREE') + days + '</span></p>';
          }).join('');
        })
        .catch(function () { out.innerHTML = '<p class="jm-cd__err">Could not check right now. Shipping is shown at checkout.</p>'; });
    }
    render(cart) {
      this.cart = cart;
      var n = cart.item_count, self = this;
      this.querySelectorAll('[data-count]').forEach(function (e) { e.textContent = n; });
      var total = cart.total_price, left = Math.max(0, this.th - total), pct = Math.min(100, Math.round(total * 1000 / this.th) / 10);
      var ship = this.querySelector('[data-ship]');
      ship.hidden = n === 0;
      ship.classList.toggle('is-done', left === 0);
      ship.innerHTML = '<div class="jm-cd__bar" role="progressbar" aria-label="Free shipping progress" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + Math.round(pct) + '"><span style="width:' + pct + '%"></span><i style="left:' + pct + '%">' + I.truck + '</i></div><p>' +
        (left > 0 ? 'Add <b>' + money(left) + '</b> more to get <b>FREE shipping</b>' : 'Congratulations! You&rsquo;ve got <b>free shipping</b>!') + '</p>';
      var body = this.querySelector('[data-body]'), foot = this.querySelector('[data-foot]');
      foot.hidden = n === 0;
      if (!n) {
        body.innerHTML = '<div class="jm-cd__empty"><p>Your cart is empty.</p><a class="jm-cd__checkout" href="' + ROOT + 'collections/all">Shop all products</a></div>';
        return;
      }
      body.innerHTML = '<ul class="jm-cd__items">' + cart.items.map(function (it) { return self.lineHTML(it); }).join('') + '</ul><div class="jm-cd__recs" data-recs></div>';
      cart.items.forEach(function (it) { self.fillColor(it); });
      this.querySelector('[data-subtotal]').textContent = money(cart.total_price);
      var save = this.querySelector('[data-save]');
      save.hidden = !(cart.total_discount > 0);
      if (cart.total_discount > 0) save.textContent = 'You save ' + money(cart.total_discount) + ' on this order';
      var note = this.querySelector('[data-note]');
      if (note && document.activeElement !== note) note.value = cart.note || '';
      this.recs(cart);
    }
    lineHTML(it) {
      var opts = (it.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; });
      var meta = opts.map(function (o) { return '<span>' + esc(o.name) + ': ' + esc(o.value) + '</span>'; }).join('');
      var disc = (it.line_level_discount_allocations || []).map(function (d) { return '<span class="jm-cd__disc">' + esc(d.discount_application && d.discount_application.title) + '</span>'; }).join('');
      var was = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
      return '<li class="jm-cd__line" data-key="' + esc(it.key) + '" data-qty="' + it.quantity + '">' +
        '<a class="jm-cd__img" href="' + it.url + '">' + (it.image ? '<img src="' + img(it.image, 200) + '" alt="' + esc(it.product_title) + '" loading="lazy">' : '') + '</a>' +
        '<div class="jm-cd__info"><a class="jm-cd__title" href="' + it.url + '">' + esc(it.product_title) + '</a>' +
        '<div class="jm-cd__meta" data-meta>' + meta + '</div>' + disc +
        '<div class="jm-cd__price"><b>' + money(it.final_line_price) + '</b>' + was + '</div>' +
        '<div class="jm-cd__row"><div class="jm-cd__qty"><button type="button" data-act="dec" aria-label="Decrease quantity">&minus;</button><span>' + it.quantity + '</span><button type="button" data-act="inc" aria-label="Increase quantity">+</button></div>' +
        '<button type="button" class="jm-cd__del" data-act="del" aria-label="Remove ' + esc(it.product_title) + '">' + I.trash + '</button></div></div></li>';
    }
    fillColor(it) {
      var self = this;
      if (!it.handle || it.product_has_only_default_variant) return;
      JM.product(it.handle).then(function (p) {
        var ci = -1;
        (p.options || []).forEach(function (o, i) { var nm = String(o && o.name ? o.name : o).toLowerCase(); if (nm === 'color' || nm === 'colour') ci = i; });
        if (ci < 0) return;
        var cur = p.variants.find(function (v) { return v.id === it.variant_id; });
        if (!cur) return;
        var line = self.querySelector('[data-key="' + (window.CSS && CSS.escape ? CSS.escape(it.key) : it.key) + '"]');
        if (!line) return;
        var opts = p.variants.filter(function (v) { return v.options.every(function (x, i) { return i === ci || x === cur.options[i]; }); });
        if (opts.length < 2) return;
        var sel = '<label class="jm-cd__color"><i style="background-color:' + cssColor(cur.options[ci]) + '"></i><select data-swap aria-label="Change colour">' + opts.map(function (v) {
          return '<option value="' + v.id + '"' + (v.id === cur.id ? ' selected' : '') + (v.available ? '' : ' disabled') + '>' + esc(v.options[ci]) + (v.available ? '' : ' (sold out)') + '</option>';
        }).join('') + '</select></label>';
        var others = (it.options_with_values || []).filter(function (o, i) { return i !== ci && o.value !== 'Default Title'; }).map(function (o) { return '<span>' + esc(o.name) + ': ' + esc(o.value) + '</span>'; }).join('');
        line.querySelector('[data-meta]').innerHTML = sel + others;
      }).catch(function () {});
    }
    recs(cart) {
      var box = this.querySelector('[data-recs]');
      if (!box || !cart.items.length) return;
      var pid = cart.items[0].product_id, inCart = cart.items.map(function (i) { return i.product_id; });
      if (this._recsPid !== pid) {
        this._recsPid = pid;
        this._recs = fetch(ROOT + 'recommendations/products.json?product_id=' + pid + '&limit=8&intent=related').then(function (r) { return r.json(); }).then(function (d) { return d.products || []; }).catch(function () { return []; });
      }
      this._recs.then(function (list) {
        list = list.filter(function (p) { return inCart.indexOf(p.id) < 0 && p.available; }).slice(0, 6);
        if (!list.length) { box.innerHTML = ''; return; }
        box.innerHTML = '<p class="jm-cd__rh">You may also like&hellip;</p><div class="jm-cd__rtrack">' + list.map(function (p) {
          var v = p.variants.find(function (x) { return x.available; });
          return '<div class="jm-cd__rc"><a href="' + p.url + '" class="jm-cd__rimg">' + (p.featured_image ? '<img src="' + img(p.featured_image, 240) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a><a href="' + p.url + '" class="jm-cd__rt">' + esc(p.title) + '</a><span class="jm-cd__rp">' + money(p.price) + '</span>' + (v ? '<button type="button" data-act="add-rec" data-id="' + v.id + '">Add</button>' : '') + '</div>';
        }).join('') + '</div>';
      });
    }
  }
  if (!customElements.get('jm-cart-drawer')) customElements.define('jm-cart-drawer', JMDrawer);

  /* ---------- quick view ---------- */
  function renderQV(box, p) {
    var names = (p.options || []).map(function (o) { return String(o && o.name ? o.name : o); });
    var single = p.variants.length === 1 && /default title/i.test(p.variants[0].title);
    var cur = p.variants.find(function (v) { return v.available; }) || p.variants[0];
    var sel = cur.options.slice();
    var imgs = p.images || [];
    var first = (cur.featured_image && cur.featured_image.src) || p.featured_image;
    var h = '<div class="jm-qv__media"><div class="jm-qv__main">' + (first ? '<img data-qv-img src="' + img(first, 900) + '" alt="' + esc(p.title) + '">' : '') + '</div>' +
      (imgs.length > 1 ? '<div class="jm-qv__thumbs">' + imgs.map(function (u, i) { return '<button type="button" data-qv-thumb="' + esc(u) + '" aria-label="Show image ' + (i + 1) + '"><img src="' + img(u, 160) + '" alt=""></button>'; }).join('') + '</div>' : '') + '</div>';
    h += '<div class="jm-qv__info"><span class="jm-badge jm-qv__badge" data-qv-badge hidden></span><h2 class="jm-qv__title">' + esc(p.title) + '</h2><div class="jm-qv__price"><b data-qv-price></b><s data-qv-was></s></div>';
    if (!single) names.forEach(function (n, i) {
      var isC = /^colou?r$/i.test(n), vals = [];
      p.variants.forEach(function (v) { if (vals.indexOf(v.options[i]) < 0) vals.push(v.options[i]); });
      h += '<div class="jm-qv__opt"><p>' + esc(n) + ': <b data-qv-lab="' + i + '"></b></p><div class="jm-qv__vals">' + vals.map(function (val) {
        return '<button type="button" class="' + (isC ? 'jm-qv__sw' : 'jm-qv__pill') + '" data-qv-opt="' + i + '" data-val="' + esc(val) + '"' + (isC ? ' style="background-color:' + cssColor(val) + '" title="' + esc(val) + '" aria-label="' + esc(val) + '"' : '') + '>' + (isC ? '' : esc(val)) + '</button>';
      }).join('') + '</div></div>';
    });
    h += '<div class="jm-qv__buy"><div class="jm-qty"><button type="button" data-qv-q="-1" aria-label="Decrease quantity">&minus;</button><input type="number" min="1" value="1" data-qv-qty aria-label="Quantity"><button type="button" data-qv-q="1" aria-label="Increase quantity">+</button></div><button type="button" class="jm-atc" data-qv-add>Add To Cart</button><button type="button" class="jm-icon-btn jm-qv__wish" data-jm-wish="' + esc(p.handle) + '" aria-label="Add to wishlist">' + I.heart + '</button></div>';
    h += '<button type="button" class="jm-buynow" data-qv-buy>Buy it now</button><a class="jm-qv__more" href="' + p.url + '">View full details &raquo;</a></div>';
    box.innerHTML = h;
    JM.paint();
    function find() { return p.variants.find(function (v) { return v.options.every(function (x, i) { return x === sel[i]; }); }); }
    function upd() {
      var v = find();
      box.querySelectorAll('[data-qv-opt]').forEach(function (b) { b.classList.toggle('is-on', sel[+b.dataset.qvOpt] === b.dataset.val); });
      box.querySelectorAll('[data-qv-lab]').forEach(function (l) { l.textContent = sel[+l.dataset.qvLab]; });
      var add = box.querySelector('[data-qv-add]'), buy = box.querySelector('[data-qv-buy]');
      if (!v) { add.disabled = true; buy.disabled = true; add.textContent = 'Unavailable'; return; }
      box.querySelector('[data-qv-price]').textContent = money(v.price);
      box.querySelector('[data-qv-was]').textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : '';
      var pct = v.compare_at_price > v.price ? Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) : 0;
      var bd = box.querySelector('[data-qv-badge]'); bd.hidden = !pct; bd.textContent = '-' + pct + '%';
      add.disabled = !v.available; buy.disabled = !v.available; add.textContent = v.available ? 'Add To Cart' : 'Sold out';
      var im = box.querySelector('[data-qv-img]');
      if (im && v.featured_image && v.featured_image.src) im.src = img(v.featured_image.src, 900);
    }
    box.onclick = function (e) {
      var o = e.target.closest('[data-qv-opt]'); if (o) { sel[+o.dataset.qvOpt] = o.dataset.val; upd(); return; }
      var t = e.target.closest('[data-qv-thumb]'); if (t) { var im = box.querySelector('[data-qv-img]'); if (im) im.src = img(t.dataset.qvThumb, 900); return; }
      var q = e.target.closest('[data-qv-q]'); if (q) { var inp = box.querySelector('[data-qv-qty]'); inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + (+q.dataset.qvQ)); return; }
      var a = e.target.closest('[data-qv-add], [data-qv-buy]');
      if (a) {
        var v = find(); if (!v || a.disabled) return;
        var qty = Math.max(1, parseInt(box.querySelector('[data-qv-qty]').value, 10) || 1);
        var buying = a.hasAttribute('data-qv-buy'), t0 = a.textContent;
        a.disabled = true; a.textContent = buying ? 'Please wait...' : 'Adding...';
        JM.add([{ id: v.id, quantity: qty }], { open: !buying })
          .then(function () { if (buying) { location.href = ROOT + 'checkout'; return; } JM.closeQV(); })
          .catch(function (err) { JM.toast(err.message); })
          .then(function () { if (!buying) { a.disabled = false; a.textContent = t0; } });
      }
    };
    upd();
  }
  JM.quickView = function (handle) {
    var m = document.querySelector('.jm-qv');
    if (!m) {
      m = document.createElement('div');
      m.className = 'jm-qv';
      m.innerHTML = '<div class="jm-qv__back" data-qv-close></div><div class="jm-qv__box" role="dialog" aria-modal="true" aria-label="Quick view"><button type="button" class="jm-qv__x" data-qv-close aria-label="Close">' + I.close + '</button><div class="jm-qv__in" data-qv-in></div></div>';
      document.body.appendChild(m);
      m.addEventListener('click', function (e) { if (e.target.closest('[data-qv-close]')) JM.closeQV(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') JM.closeQV(); });
    }
    var box = m.querySelector('[data-qv-in]');
    box.innerHTML = '<div class="jm-qv__load">Loading...</div>';
    m.classList.add('is-open');
    document.documentElement.classList.add('jm-lock');
    JM.product(handle).then(function (p) { renderQV(box, p); }).catch(function () { box.innerHTML = '<div class="jm-qv__load">Could not load this product.</div>'; });
  };
  JM.closeQV = function () {
    var m = document.querySelector('.jm-qv');
    if (!m || !m.classList.contains('is-open')) return;
    m.classList.remove('is-open');
    if (!(JM.drawer && JM.drawer.isOpen)) document.documentElement.classList.remove('jm-lock');
  };

  /* ---------- delegated clicks ---------- */
  document.addEventListener('click', function (e) {
    var w = e.target.closest('[data-jm-wish]');
    if (w) {
      e.preventDefault();
      var added = JM.wish.toggle(w.getAttribute('data-jm-wish'));
      JM.toast(added ? 'Added to wishlist' : 'Removed from wishlist', added ? ROOT + 'pages/wishlist' : null, 'View wishlist');
      return;
    }
    var q = e.target.closest('[data-jm-qv]');
    if (q) { e.preventDefault(); JM.quickView(q.getAttribute('data-jm-qv')); return; }
    var t = e.target.closest('[data-testid="cart-drawer-trigger"], [data-jm-open-cart]');
    if (t && JM.drawer) { e.preventDefault(); e.stopPropagation(); JM.drawer.toggle(); }
  }, true);

  function init() {
    JM.paint();
    var to;
    new MutationObserver(function () { clearTimeout(to); to = setTimeout(JM.paint, 80); }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
